// extracted by mini-css-extract-plugin
export var main = "settingLayout-module--main--IfDAD";
export var main2 = "settingLayout-module--main2--71yg_";